<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="100%"
      img-height="100%"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Slides with image only -->
      <div v-for="banner in banners" :key="banner.id">
        <a v-if="banners.indexOf(banner) > 0" :href="banner.url" target="_blank"
          ><b-carousel-slide :img-src="banner.image"></b-carousel-slide>
        </a>
        <a v-else :href="banner.url"
          ><b-carousel-slide :img-src="banner.image"></b-carousel-slide>
        </a>
      </div>
    </b-carousel>
    <div class="carouseol__news">
      <CardNews :cardNews="cardNews"></CardNews>
    </div>
    <CurriculumBlock></CurriculumBlock>
    <div class="container">
      <div class="row mb-4">
        <div class="col-12 col-sm-6">
          <StudentCarouselBlock></StudentCarouselBlock>
        </div>
        <div class="col-12 col-sm-6">
          <ListBlock blogName="교육결과물"></ListBlock>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6">
          <ListBlock blogName="기술블로그"></ListBlock>
        </div>
        <div class="col-12 col-sm-6">
          <ListBlock blogName="교육블로그"></ListBlock>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardNews from "@/components/home-components/CardNews.vue";
import StudentCarouselBlock from "@/components/Blocks/StudentCarouselBlock.vue";
import ListBlock from "@/components/Blocks/ListBlock.vue";
import CurriculumBlock from "@/components/Blocks/CurriculumBlock.vue";

export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      banners: [
        {
          id: 101,
          url: "#/portfolio",
          image: require("@/assets/images/home_banners/banner-01.png")
        },
        {
          id: 102,
          url: "https://codershigh.dscloud.biz/Codershigh_Online/#/",
          image: require("@/assets/images/home_banners/banner-02.png")
        },
        {
          id: 103,
          url: "http://codershigh.dscloud.biz:30004/",
          image: require("@/assets/images/home_banners/banner-03.png")
        }
      ],
      cardNews: [
        {
          id: 1,
          newsImage: require("@/assets/images/cardNews/news1.jpg"),
          intervieweeInfo: "현)한양대학교 재학생",
          students: "전하영, 정상운, 최준호",
          newsAddress:
            "https://www.facebook.com/codershighteam/posts/1228818117320856"
        },
        {
          id: 2,
          newsImage: require("@/assets/images/cardNews/news2.jpg"),
          intervieweeInfo: "현)중앙대학교 재학생",
          students: "안웅기, 서보민, 이지우",
          newsAddress:
            "https://www.facebook.com/codershighteam/posts/1237510246451643"
        },
        {
          id: 3,
          newsImage: require("@/assets/images/cardNews/news3.jpg"),
          intervieweeInfo: "현)삼성전자 앱 개발부",
          students: "염혜리",
          newsAddress:
            "https://www.facebook.com/codershighteam/posts/1249197898616211"
        },
        {
          id: 4,
          newsImage: require("@/assets/images/cardNews/news4.jpg"),
          intervieweeInfo: "현)카카오 iOS 앱 개발부",
          students: "이채원",
          newsAddress:
            "https://www.facebook.com/codershighteam/posts/1271911513011516/"
        }
      ]
    };
  },
  components: {
    CardNews,
    StudentCarouselBlock,
    ListBlock,
    CurriculumBlock
  }
};
</script>

<style>
.hline {
  border-bottom: 2px solid #384452;
}
</style>
